import React from 'react';
import {Button, Popconfirm, Icon, message, Divider, Dropdown, Menu} from 'antd';
import { Link } from 'react-router-dom';
import { observable, toJS, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import {withRouter} from 'react-router'

import ListTable from '@components/ListTable/ListTable.jsx';

import agent_store, { pagination_store, filter_store } from '@store/Agent/AgentStore';
import user_store, { pagination_store2, filter_store2, ItemStore } from '@store/User/UserList/UserStore';
import agent_detail_store from '@store/Agent/AgentDetailStore';
import change_agent_store from '@store/Agent/ChangeAgentStore.js';

import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';
import login_user_store from '@src/Store/LoginUser/LoginUserStore';
import GoToPage from '@common/GoToPage';

@withRouter
@observer
class AgentListTable extends React.Component {
  constructor(props)
  {
    super();
    let id = props.match.params.id;
    let username = props.match.params.username;
    this.updateDatas(id,username)
  }

  componentWillReceiveProps(nextProps){


    let id = nextProps.match.params.id;
    let username = nextProps.match.params.username;
    this.updateDatas(id,username);

  }

  updateDatas(id,username)
  {
    agent_store.currentUserId = id;

    //刷新页面
    agent_store.reloadDatas();
  }

  columns = [
    {
      key:'pet_name',
      sorter:true,
      title: '昵称',
      render( text, record, index ) {
        return (
          <span onClick={() => {
            // console.log(record);
            GoToPage.goMySummaryPath( record.id, record.pet_name )
          }}>
            <a href="javascript:;"
              className="link-hover">{record.pet_name}</a>
          </span>
        )
      }
    },
    {
      key:'nick_name',
      sorter:true,
      title: '账号',
      render( text, record, index ) {
        return (
          <span onClick={() => {
            // console.log(record);
            GoToPage.goMySummaryPath( record.id, record.pet_name )
          }}>
            <a href="javascript:;"
              className="link-hover">{record.nick_name}</a>
          </span>
        )
      }
    },
    {
      key:'proxy_pet_name',
      sorter:false,
      title: '上级代理',
      render( text, record, index ) {

        if (login_user_store.pet_name == record.proxy_pet_name)
        {
          return (
            <span>
              {record.proxy_pet_name}
          </span>
          )
        }

        return (
          <span onClick={() => {
            // console.log(record);
            GoToPage.goMySummaryPath( record.proxy_id, record.proxy_pet_name )
          }}>
            <a href="javascript:;"
              className="link-hover">{record.proxy_pet_name}</a>
          </span>
        )
      }
    },
    {
      key:'get_radio',
      sorter:false,
      title: '投注返佣',
      dataIndex: 'get_radio',
    },
    {
      key:'proxy_num',
      sorter:true,
      title: '下级代理',
      render(text, record, index) {
        return (
        <span>
         { record.proxy_num }
        </span>
        )
        // return (
        //   <Link
        //   className="link-hover"
        //     onClick={() => {
        //       breadcrumb_store.addProxyItem(record.id,record.pet_name);
        //     }}
        //     to={breadcrumb_store.getProxyItemPath(record.id,record.pet_name)}
        //   >{record.proxy_num}</Link>
        // 
      }
    },
    {
      key:'user_num',
      sorter:true,
      title: '下线会员',
      render(text, record, index) {
        return (
          <span>
          { record.user_num }
         </span>
          // <Link
          //   className="link-hover"
          //   onClick={() => {
          //     breadcrumb_store.addUserItem(ItemStore.Type_Proxy,record.id,record.pet_name);
          //   }}
          //   to={breadcrumb_store.getUserItemPath(ItemStore.Type_Proxy,record.id,record.pet_name)}
          // >{record.user_num}</Link>
        )
      }
    },
    // {
    //   key:'user_proxy_pay_money',
    //   sorter:true,
    //   title: '下级总充值',
    //   className: 'column-money',
    //   render(text, record, index) {
    //     return (
    //       <span>
    //         { window.FormatAmount(record.user_proxy_pay_money)}
    //         {/* <a href="javascript:;"
    //           className="link-hover"
    //           onClick={() => {
    //           let filter = {
    //             agent:record.pet_name,
    //           }
    //           GoToPage.goRechargePath(filter)
    //         }}>
    //         { window.FormatAmount(record.user_proxy_pay_money)}
    //         </a> */}
    //       </span>
    //     )
    //   }
    // },
    // {
    //   key:'user_pay_money',
    //   sorter:true,
    //   title: '个人总充值',
    //   className: 'column-money',
    //   render(text, record, index) {
    //     return (
    //       <span>
    //         { window.FormatAmount(record.user_pay_money)}
    //         {/* <a href="javascript:;"
    //           className="link-hover"
    //           onClick={() => {
    //             let filter = {
    //               agent:record.proxy_pet_name,
    //               search:record.nick_name,
    //             }
    //             GoToPage.goRechargePath(filter)
    //           }}>
    //         { window.FormatAmount(record.user_pay_money)}
    //         </a> */}
    //       </span>
    //     )
    //   }
    // },
    // {
    //   key:'yinkui',
    //   sorter:true,
    //   title: '个人总输赢',
    //   className: 'column-money',
    //   render(text, record, index) {
    //     let style = undefined;
    //     let title = undefined;

    //     let money = window.FormatAmount(record.yingkui);

    //     if (record.yingkui > 0) {
    //       style = {
    //         color: '#c43827'
    //       };
    //       title = `+${money}`;
    //     }
    //     else if (record.yingkui < 0) {
    //       style = {
    //         color: '#1c9f6d'
    //       };
    //       title = `${money}`;
    //     }
    //     else {
    //       title = `${money}`;
    //     }

    //     return (
    //       <span style={style}>
    //       {title}
    //     </span>
    //     )
    //   }
    // },
    {
      key:'balance',
      sorter:true,
      title: '余额',
      className: 'column-money',
      render(text, record, index) {
        return (
          <span>
            { window.FormatAmount(record.balance) }
          </span>
        )
      }
    },
    {
      key:'mosaic_gold',
      sorter:true,
      title: '彩金',
      className: 'column-money',
      render(text, record, index) {
        return (
          <span>
            { window.FormatAmount(record.mosaic_gold) }
          </span>
        )
      }
    },
    {
      title: '操作',
      render(text, record, index) {

        const menu = (
          <Menu>
            <Menu.Item>
              <span
                onClick={() => {
                  // console.log(record);
                  GoToPage.goMySummaryPath( record.id, record.pet_name )
                }}>代理统计</span>
            </Menu.Item>
            <Menu.Item>
              <span
                onClick={()=>{
                  let filter = {
                    agent:record.proxy_pet_name,
                    search:record.pet_name,
                  }
                  GoToPage.goRechargePath(filter)
                }}
              >个人充值记录</span>
            </Menu.Item>
            <Menu.Item>
              <span
                onClick={()=>{
                  let filter = {
                    agent:record.proxy_pet_name,
                    search:record.pet_name,
                  }
                  GoToPage.goCashPath(filter)
                }}
              >个人提现记录</span>
            </Menu.Item>
            <Menu.Item>
              <span
                onClick={()=>{
                  let filter = {
                    agent:record.proxy_nick_name,
                    search:record.pet_name,
                  }
                  GoToPage.goRakeBackPath(filter)
                }}
              >个人投注记录</span>
            </Menu.Item>
            {
              login_user_store.isFirstLevel ? (
                <Menu.Item>
                  <span
                    onClick={()=>{
                      change_agent_store.openModal(record);
                    }}
                  >代理转移</span>
                </Menu.Item>
              ) : null
            }
          </Menu>
        );

        return (
          <Dropdown
            overlay={menu}
            placement="bottomRight"
          >
            <Icon
              type="setting"
              style={{
                fontSize: '20px'
              }}
              theme="filled"
            />
          </Dropdown>
        )
      }
    },
  ];

  componentDidMount() {
    // agent_store.reloadDatas();
  }

  componentWillUnmount() {
    filter_store.resetAttr();
  }

  /**
   * 分页器点击回调
   * @param {number} page
   * @param {number} size
   */
  pagination_callback(page, size, order_by) {
    agent_store.searchByFilter({
      page: page,
      page_size: size,
      ...order_by,
    })
  }

  render() {
    return (
      <ListTable
        data_source={ toJS(agent_store.item_array) }
        columns={ this.columns }
        pagination={
          {
            // 当前页
            current: pagination_store.page_cur,
            // 每页条数
            pageSize: pagination_store.page_size,
            // 总数据条数
            total: pagination_store.data_total,
            // 页码候选列表
            pageSizeOptions: pagination_store.page_size_options,
            // // 页码变化回调
            // onChange:( next_page, size ) => {
            //   this.pagination_callback(next_page, size)
            // },
            // // 每页显示条数回调
            // onShowSizeChange: ( current, size ) => {
            //   this.pagination_callback(current, size)
            // }
          }
        }
        onChange={
          (pagination, filters, sorter) => {
            let current = pagination.current;
            let page_size = pagination.pageSize;

            let order_by = undefined;
            if (sorter.columnKey !== undefined)
            {
              let desc = 0;
              if (sorter.order == 'descend')
              {
                desc = 1;
              }
              order_by = {
                order:sorter.columnKey,
                desc:desc
              }
            }

            this.pagination_callback(current, page_size, order_by);
          }
        }
      />
    )
  }
}

export default AgentListTable;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Agent/AgentList/AgentListTable.jsx